import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
import { IconButton } from '@atlaskit/button/new';
import VideoPauseIcon from '@atlaskit/icon/core/video-pause';
import VideoPlayIcon from '@atlaskit/icon/core/video-play';

export const i18n = defineMessages({
	pauseButtonLabel: {
		id: 'create-with-rovo-announcement-splash.carouselControl.pauseButtonLabel',
		defaultMessage: 'Pause',
		description: 'Label for the pause button on the carousel control',
	},
	resumeButtonLabel: {
		id: 'create-with-rovo-announcement-splash.carouselControl.resumeButtonLabel',
		defaultMessage: 'Resume',
		description: 'Label for the play button on the carousel control',
	},
});

type CarouselControlProps = {
	isPlaying: boolean;
	onClick: () => void;
};

export const CarouselControl = ({ isPlaying, onClick }: CarouselControlProps) => {
	const { formatMessage } = useIntl();

	const iconButtonLabel = isPlaying
		? formatMessage(i18n.pauseButtonLabel)
		: formatMessage(i18n.resumeButtonLabel);

	const IconButtonIcon = isPlaying ? VideoPauseIcon : VideoPlayIcon;

	return (
		<IconButton
			appearance="default"
			label={iconButtonLabel}
			icon={(iconProps) => <IconButtonIcon {...iconProps} color={token('color.icon')} />}
			shape="circle"
			onClick={onClick}
		/>
	);
};
